import { useAsyncList } from "@/ds";
import { listarCotacoesReferencia } from "@/modules/financeiro-configuracoes";
import type { CotacaoReferenciaItem } from "@/modules/financeiro-configuracoes";

export const CONSULTA_ATIVAS_ERRO = "Não foi possível consultar as cotações ativas da moeda.";

interface Params {
  moedaId: string;
  enabled: boolean;
}

export function useAtivasDaMoeda({ moedaId, enabled }: Params) {
  const lista = useAsyncList<{ moedaId: string }, CotacaoReferenciaItem>({
    fetcher: async (params, signal) => {
      const { items, total } = await listarCotacoesReferencia(
        { moedaId: params.moedaId, situacao: "ATIVAS", pageSize: 2 },
        { signal },
      );
      return { items, total };
    },
    params: { moedaId },
    enabled,
    forbiddenMessage: CONSULTA_ATIVAS_ERRO,
    errorMessage: CONSULTA_ATIVAS_ERRO,
  });

  return { unicaAtiva: lista.status === "success" && lista.total === 1 };
}
